export default "__VITE_ASSET__BUa2m8xg__"